import React from 'react'
import { View } from 'react-native'
import { useScrollAnchors } from '../../utils/ui'

export function Section({
  children,
  background,
  paddingTop,
  paddingBottom,
  fullHeight = false,
  anchorId,
}: {
  children: React.ReactNode
  background: string
  paddingTop: number
  paddingBottom: number
  fullHeight?: boolean
  anchorId?: string
}) {
  const { registerAnchor } = useScrollAnchors()

  return (
    <View
      onLayout={event => {
        if (anchorId) {
          registerAnchor(anchorId, event.nativeEvent.layout.y)
        }
      }}
      style={{
        backgroundColor: background,
        paddingTop,
        paddingBottom,
        minHeight: fullHeight ? 760 : undefined,
      }}
    >
      {children}
    </View>
  )
}
